export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_ERROR = "GET_NOTIFICATION_ERROR";

export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const READ_NOTIFICATION_SUCCESS = "READ_NOTIFICATION_SUCCESS";
export const READ_NOTIFICATION_ERROR = "READ_NOTIFICATION_ERROR";

export const READ_ALL_NOTIFICATIONS = "READ_ALL_NOTIFICATIONS";
export const READ_ALL_NOTIFICATIONS_SUCCESS = "READ_ALL_NOTIFICATIONS_SUCCESS";
export const READ_ALL_NOTIFICATIONS_ERROR = "READ_ALL_NOTIFICATIONS_ERROR";